import React, { FC } from 'react'

import {
  mailruPartnerIds,
  mambaPartnerIds,
  wambaPartnerIds,
  yonjaPartnerIds,
} from 'common/constants'
import wamba from 'components/presentational/Logo/wamba.svg'
import yonja from 'components/presentational/Logo/yonja.svg'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

import { LogoMambaSwitchSize } from './LogoMambaSwitchSize'

export const LogoSwitch: FC = () => {
  const { partnerId, partner } = useShallowEqualSelector(
    ({ systemReducer: { partnerId, partner } }) => ({
      partnerId,
      partner,
    })
  )

  switch (partnerId) {
    case mambaPartnerIds[0]:
    case mambaPartnerIds[1]:
      return <LogoMambaSwitchSize />

    case wambaPartnerIds[0]:
    case wambaPartnerIds[1]:
      return <LogoImage logo={wamba} />

    case mailruPartnerIds[0]:
    case mailruPartnerIds[1]:
      return null

    case yonjaPartnerIds[0]:
    case yonjaPartnerIds[1]:
      return <LogoImage logo={yonja} />
  }

  if (partner && partner.logoUrl) {
    return <LogoImage logo={partner.logoUrl} />
  }
}

const LogoImage: FC<{ logo: string }> = ({ logo }) => {
  return <img src={logo} alt="logo" />
}
